export default "__VITE_ASSET__BsApNrD3__"